import isEmpty from 'lodash/isEmpty';
import { isTimeEnded, convertDateTimeToETTimezone } from 'core/utils/helpers/date';
import { convertDollarAmountToNumber } from 'core/utils/helpers/numbers';

export const parseBonusTrackerOffer = (bonusTrackerOffer) => {
  if (isEmpty(bonusTrackerOffer)) {
    return {};
  }

  const {
    startDate, endDate, offers, name: bonusName, landingUrl,
  } = bonusTrackerOffer;
  const offer = offers[0];
  const { totalAmountSpent = '$0', qualifyingSpendTiers } = offer;
  const totalAmountSpentNumber = convertDollarAmountToNumber(totalAmountSpent);
  const isEnded = isTimeEnded(endDate);
  const numberOfTiers = qualifyingSpendTiers.length;
  const firstTier = qualifyingSpendTiers[0];
  const lastTier = qualifyingSpendTiers[numberOfTiers - 1];
  const { brandCurrency } = qualifyingSpendTiers[0];
  const tierInProgress = qualifyingSpendTiers.find(({ isQualified }) => !isQualified);
  const tierInProgressMinimumSpendNumber = tierInProgress && convertDollarAmountToNumber(tierInProgress.minimumSpend);
  const tierInProgressLeftAmount = tierInProgressMinimumSpendNumber - totalAmountSpentNumber;
  const lastEarnedTier = qualifyingSpendTiers.findLast(({ isQualified }) => isQualified);
  const endDateEasternTime = convertDateTimeToETTimezone(endDate, 'America/New_York').format('MM/DD/YY');
  const { terms } = offer;
  const tiers = qualifyingSpendTiers;

  return {
    startDate, // Bonus start date
    endDate, // Bonus end date
    bonusName, // Bonus name
    landingUrl, // CTA url for Bonus in progress
    terms, // Bonus terms and conditions
    isEnded, // is Bonus ended
    endDateEasternTime, // Bonus formatted end date converted to ET Time Zone
    totalAmountSpentNumber, // the amount of $$$ spent by the user so far
    numberOfTiers, // total number of tiers in Bonus
    firstTier, // first tier in Bonus
    lastTier, // last tier in Bonus
    tiers, // list of all tiers in Bonus
    lastEarnedTier, // the last tier already earned by user (if exists)
    tierInProgress, // tier which is in progress right now
    tierInProgressMinimumSpendNumber, // the overal amount of $$$ needed to earn current tier
    tierInProgressLeftAmount, // how many more $$$ user need to spend to earn current tier
    brandCurrency, // currency (e.g., miles, points)
  };
};
